import styled from 'styled-components';

export const OtpPopUpOverlay = styled.div(
    props => `
        width:100%;
        display: flex;
        position: fixed;
        top:0;
        left:0;
        bottom:0;
        right: 0;
        background-color: rgba(0,0,0,0.5);
        align-items: center;
        justify-content: center;
    `
);

export const OtpPopUpBlock = styled.div(
    props => `
        width:55rem;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.4);
        border-radius: 1rem;
    `
);

export const OtpPopHead = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${props.theme.spacing.large.l15};
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    `
);

export const OtpPopHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font26};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const OtpPopBodyWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        padding: ${props.theme.spacing.large.l15} 0;
        flex-direction: column;
    `
);

export const OtpWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: 0 ${props.theme.spacing.large.l15};
    `
);

export const OtpInfoText = styled.p(
    props => `
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.grey.base};
        line-height: 1.3;
    `
)

export const OtpFooterBtnWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        border-top: 1px solid ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l15} 0; 
        align-items: center;
        justify-content: flex-end;
    `
);

export const CancelBtn = styled.button(
    props => `
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.grey.base};
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `
)

export const SubmitBtn = styled.button(
    props => `
        width:10rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
        outline: none;
        border: none;
        font-size: ${props.theme.font.font16};
        color: ${props.theme.colors.white.base};
        background-color: ${props.theme.colors.blue.base};
        margin-left: ${props.theme.spacing.large.l20};
        text-transform: uppercase;
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;
    `
)

export const AadharForm = styled.form(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    `
);

export const ErrorText = styled.span(
    props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.large.font14};
          padding-bottom: ${props.theme.spacing.base};
          text-align: ${props.theme.font.textAlign.left};
          width: 100%;
          text-transform: ${props.theme.font.textTransform.capital};
      `,
  );